module.exports = __webpack_public_path__ + "static/media/B86D25C3-6729-4B79-8806-E7FC58CE884D.88d33ea9.jpeg";